import React, { ReactNode, useEffect, useMemo, useState } from "react";
import {
  AppShell,
  Avatar,
  Container,
  Group,
  Menu,
  Text,
  UnstyledButton,
} from "@mantine/core";
import { IconChevronDown, IconLogout } from "@tabler/icons-react";
import { getAuth } from "firebase/auth";
import { Link } from "react-router-dom";
import {
  getDisplayName,
  getStoredUserProfile,
  logout,
  StoredUserProfile,
} from "./auth/signin";

interface AppLayoutProps {
  children: ReactNode;
  pageTitle: string;
}

export const AppLayout: React.FC<AppLayoutProps> = ({ children }) => {
  const [profile, setProfile] = useState<StoredUserProfile | null>(() =>
    getStoredUserProfile()
  );

  useEffect(() => {
    if (profile) return;
    const firebaseUser = getAuth().currentUser;
    if (!firebaseUser) return;
    const fallback: StoredUserProfile = {
      id: localStorage.getItem("user") || firebaseUser.uid,
      email: firebaseUser.email || "",
      firstName: firebaseUser.displayName?.split(" ")[0] || "",
      lastName: firebaseUser.displayName?.split(" ").slice(1).join(" ") || "",
      imageUrl: firebaseUser.photoURL || "",
    };
    localStorage.setItem("userProfile", JSON.stringify(fallback));
    setProfile(fallback);
  }, [profile]);

  const displayName = useMemo(() => getDisplayName(profile), [profile]);

  return (
    <AppShell padding="md" header={{ height: 72 }} bg="#F5F1EE">
      <AppShell.Header p="xs" style={{ backgroundColor: "#000102" }}>
        <Container
          size="100%"
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "space-between",
            height: "100%",
          }}
        >
          <Link to="/" style={{ display: "flex", alignItems: "center" }}>
            <img
              src="/shorton_logo.png"
              alt="Shorton Logo"
              style={{ height: "24px" }}
            />
          </Link>

          <Menu shadow="md" width={220} position="bottom-end">
            <Menu.Target>
              <UnstyledButton
                style={{
                  color: "white",
                  borderRadius: 8,
                  padding: "6px 10px",
                }}
              >
                <Group gap="xs" wrap="nowrap">
                  <Avatar
                    src={profile?.imageUrl || undefined}
                    alt={displayName}
                    radius="xl"
                    size={28}
                    color="gray"
                  >
                    {displayName.charAt(0).toUpperCase()}
                  </Avatar>
                  <Text size="sm" c="white" style={{ lineHeight: 1.2 }}>
                    {displayName}
                  </Text>
                  <IconChevronDown size={14} color="white" />
                </Group>
              </UnstyledButton>
            </Menu.Target>

            <Menu.Dropdown>
              {profile?.email && (
                <Menu.Label>{profile.email}</Menu.Label>
              )}
              <Menu.Item
                color="red"
                leftSection={<IconLogout size={14} />}
                onClick={() => {
                  void logout();
                }}
              >
                Log out
              </Menu.Item>
            </Menu.Dropdown>
          </Menu>
        </Container>
      </AppShell.Header>
      <AppShell.Main>
        <Container size="100%" py="md">
          {children}
        </Container>
      </AppShell.Main>
    </AppShell>
  );
};

export default AppLayout;
